import { render, staticRenderFns } from "./ScantrustProLogo.vue?vue&type=template&id=857f69a0"
import script from "./ScantrustProLogo.vue?vue&type=script&lang=js"
export * from "./ScantrustProLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports